import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, withTypography } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { primitive, spacing } from 'styles/constants';

const styles = StyleSheet.create({
  textContainer: {
    flexDirection: 'row',
    marginBottom: spacing.$6,
  },
  transferBalanceContent: {
    alignItems: 'flex-start',
    alignSelf: 'center',
    backgroundColor: primitive.$white,
    borderRadius: 10,
    flexDirection: 'column',
    marginVertical: spacing.$4,
    padding: spacing.$4,
    width: 343,
  },
  transferBalanceContentDesktop: {
    width: 528,
  },
});

export const TransferBalanceContent = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return React.createElement(Box, {
    ...props,
    style: [
      styles.transferBalanceContent,
      isDesktop && styles.transferBalanceContentDesktop,
      style,
    ],
  });
};

export const TextContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.textContainer, style] });

export const BalanceText = withTypography({ fontSize: 'md' });
